// extracted by mini-css-extract-plugin
export default {"circled-number":"circled-number-e653","big":"big-f3b1","number":"number-2fa8"};